import React, { Component } from 'react'

export default class VectorServiceType extends Component {
    render() {
        return (
            
      <section className="pricing-area pt-70 pb-70">
      <div className="container">
        <div className="col-12">
          <div className="services-details-text">

            <h3>Vector Services</h3>
            <p>If you are new to this field and are not knowing anything about vector, then we are having something for you. <b>Do you know what vector artwork is?</b> Vector artwork is one of the most important things in the field of business and marketing. Ergo, this art encourages us to provide you with the best high-quality designs. We can easily convert the designs and vector artwork according to your choices.</p>

            <h3>Vector Conversion</h3>	
            <p>Raster is the image having many rectangular elements and square elements and are known as pixels. Therefore, all the details mixed up together are referred to as raster. Raster images are having their own benefits and purposes, hence, they are much better than vectors. When we use in promotional and branding materials, then vectors have no parallel use to them.</p>

            <h3>Raster to Vector Artwork</h3>	
            <p>Our services are best when it comes to converting complex raster to vector artwork, the formats offered by our company are EPS, CDR and AL. We can easily do the conversion according to your needs and choices. So, if you are searching for a quick quality raster service, then try us.</p>

            <h3>Vectorization</h3>	
            <p>Quality digitizing services were set up in 2008 and from then only we are experts in this field. Therefore, the excellent services of ours helped us in gaining a lot of appreciation from our clients</p>

            <h3>Why outsource Quality Digitizing?</h3>	
            <p>Do you know that we can easily save up to 70% by outsourcing designs. Try our services and you can easily make your clients say WOW and excellent. Ergo, we try out every possible thing that makes our clients happy as customers are the first priority of ours.</p>
            <h4>Think about hiring us today only!! Contact us through <a href="mailto:kristilopez01@gmail.com"><i className="bx bxs-envelope" />kristilopez01@gmail.com</a></h4>	  
            
          </div>
        </div>
      </div>
    </section>
        )
    }
}
